import { render } from "./CSVExportNotification.vue?vue&type=template&id=9a84e958&scoped=true"
import script from "./CSVExportNotification.vue?vue&type=script&lang=js"
export * from "./CSVExportNotification.vue?vue&type=script&lang=js"

import "./CSVExportNotification.vue?vue&type=style&index=0&id=9a84e958&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a84e958"]])

export default __exports__